import axiosInstance from 'helpers/axiosInstance';

interface CreateEligibilityStatus {
  result: string;
}

export const updateEligibilityToNoCheckStatus = (id: string) => {
  const url = `/patients/patients/${id}/eligibility/no_check`;

  return axiosInstance
    .post<CreateEligibilityStatus>(url)
    .then(response => {
      return response.data.result;
    })
    .catch(error => {
      return error;
    });
};
